<div class="pdf-container" *ngIf="pdfFile && form && isLoaded">
    <ngx-extended-pdf-viewer [src]="pdfFile" 
    useBrowserLocale="true" 
    [showToolbar]="false"
    [height]="viewerHeight ?? (isMobileView ? '80vh' : '90vh')"
    [minZoom]="minZoom" 
    [maxZoom]="maxZoom"
    [zoom]="zoom"
    [textLayer]="true"
    (zoomChange)="onZoomChange($event)"
    (pagesLoaded)="attachFormFieldListeners($event)" 
    (pageRendered)="onPageRendered($event)">
    </ngx-extended-pdf-viewer>
</div>